import { render, staticRenderFns } from "./InformeCard.vue?vue&type=template&id=7c9b4ded"
import script from "./InformeCard.vue?vue&type=script&lang=js"
export * from "./InformeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports